import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDKVFpcq0-ZUjlT6cV2iIndbyU9aPkidPE",
  authDomain: "bible-contest-6f614.firebaseapp.com",
  projectId: "bible-contest-6f614",
  storageBucket: "bible-contest-6f614.appspot.com",
  messagingSenderId: "339812846342",
  appId: "1:339812846342:web:bd0df95b63e129e6eeec87"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);
export const storage = getStorage(app);